export default () => {
  const el = document.querySelector(".js-promo-bar") as HTMLElement;

  if (!el) {
    return;
  }

  let close = el.querySelector(".js-close") as HTMLElement;

  const showPromoBar = () => {
    el.classList.remove("is-hidden");

    document.body.classList.add("has-promo-bar");
  };

  const disablePromoBar = () => {
    // if a user closes the promo bar, give them 24 hours before showing it again
    window.sessionStorage.setItem(
      "closedPromos",
      (new Date().getTime() + 86400000).toString()
    );
    el.classList.add("is-hidden");
    document.body.classList.remove("has-promo-bar");
  };

  // check to make sure its not already closed
  let closed = window.sessionStorage.getItem("closedPromos");

  if (!closed || parseInt(closed) < new Date().getTime()) {
    showPromoBar();

    let i = 0;
    let interval: any = null;

    const rotate = () => {
      i++;
      if (i >= contents.length) {
        i = 0;
      }
      contents.forEach((content, index) => {
        if (index === i) {
          content.classList.remove("is-hidden");
        } else {
          content.classList.add("is-hidden");
        }
      });
    };

    // if hovering over the promo bar, pause the rotation
    el.addEventListener("mouseenter", () => {
      if (interval) {
        clearInterval(interval);
      }
    });

    el.addEventListener("mouseleave", () => {
      interval = setInterval(rotate, 4000);
    });

    // if more that 1 .promo-bar__content elements within the promo bar, show the next one
    // every 4 seconds
    let contents = Array.from(el.querySelectorAll(".promo-bar__content"));
    if (contents.length > 1) {
      interval = setInterval(rotate, 4000);
    }
  }

  if (close) {
    close.addEventListener("click", () => {
      disablePromoBar();
    });
  }
};
